export default "__VITE_ASSET__0986e148__"